export default "__VITE_ASSET__B$h9sBuo__"